import axios from '@/lib/axios';
import { InvoiceTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1971. 請求タスク管理会計確認チェック編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:id/update_accounting_confirmed
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  accounting_confirmed: boolean;
};

const updateInvoiceTaskAccountingConfirmed = (props: Props): Promise<InvoiceTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/update_accounting_confirmed`,
    props
  );
};

export const useUpdateInvoiceTaskAccountingConfirmed = () => {
  return useMutation({
    mutationFn: updateInvoiceTaskAccountingConfirmed,
  });
};
